export enum RetestReasonEnum {
    UNEXPECTED_RESULTS = 1,
    NO_RESULTS = 2,
    COMBINED_RESULTS = 3,
}

export const retestReasonNames: Record<RetestReasonEnum, string> = {
    [RetestReasonEnum.UNEXPECTED_RESULTS]: 'order.checkMate.list.retestReason.unexpected',
    [RetestReasonEnum.NO_RESULTS]: 'order.checkMate.list.retestReason.noResults',
    [RetestReasonEnum.COMBINED_RESULTS]: 'order.checkMate.list.retestReason.combinedResults',
};
